/**
 * Created with IntelliJ IDEA.
 * User: abahlk
 * Date: 22.08.13
 * Time: 13:48
 * To change this template use File | Settings | File Templates.
 */

import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { SecurityErrorLOFactory } from "./SecurityErrorLOFactory";

export class TrackingSecurityErrorLOFactory extends SecurityErrorLOFactory {

    private static PARAM_REQUEST_DATA: string = "requestData";
    private static PARAM_EVENT_DATA: string = "eventData";

    private _eventId: number;
    private _eventData: string;

    constructor(subErrorId: number, operationText: string, url: string, eventId: number, eventData: string) {
        super(subErrorId, operationText, url);

        this._eventId = eventId;
        this._eventData = eventData;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Update with customData
        lo.logData.set(TrackingSecurityErrorLOFactory.PARAM_REQUEST_DATA, this._eventId.toString());
        lo.logData.set(TrackingSecurityErrorLOFactory.PARAM_EVENT_DATA, this._eventData);

        return lo;
    }
}
